<template>
  <div v-if="item.price" class="d-flex flex-column align-end ml-2">
    <sf-heading ref="priceRef" :class="{ 'text-disabled': !isSelected }">
      {{ formatMoneyShowZeroPrice(price, false) }}
    </sf-heading>
    <template v-if="item.discount">
      <span
        ref="discountRef"
        class="text-medium-emphasis"
        :class="{ 'text-disabled': !isSelected }"
      >
        {{ formatDiscount(item.discount) }}
      </span>
    </template>
  </div>
</template>

<script setup lang="ts">
import SfHeading from '@/components/text/SfHeading.vue'
import { formatMoneyShowZeroPrice } from '@/modules/product/helpers'
import { formatDiscount } from '@/modules/quote/helpers'
import { Money, OrderItem, QuoteItem, SimplePrice } from '@/types/index'
import { computed, PropType } from 'vue'

const props = defineProps({
  item: {
    type: Object as PropType<QuoteItem | OrderItem>,
    required: true
  },
  isSelected: {
    type: Boolean,
    default: true
  }
})

const price = computed<Money | undefined>(() => {
  if (props.item.price && (props.item.price as SimplePrice).resellPrice) {
    return (props.item.price as SimplePrice).resellPrice || undefined
  }

  if ((props.item as OrderItem).rawPrice) {
    return (props.item as OrderItem).rawPrice || undefined
  }

  return (props.item as OrderItem).price || undefined
})
</script>
